/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'
import dotQuestions from 'images/coin-pages/questions/dot.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const dotPage: ICoinPageData = {
  title: 'coin_324',
  description: 'coin_325',
  // description:
  //   'Borrow Polkadot against Stablecoins.' +
  //   ` Get a stablecoin loan using your DOT coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Polkadot' }) }} />
  ),
  questionsBlock: {
    image: dotQuestions,
    questions: [
      {
        title: 'coin_326',
        answer: 'coin_327',
      },
      {
        title: 'coin_328',
        answer: 'coin_329',
      },
      {
        title: 'coin_330',
        answer: 'coin_331',
      },
      {
        title: 'coin_332',
        answer: 'coin_333',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Polkadot (DOT)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_334',
        text: ['coin_336'],
      },
      {
        title: 'coin_335',
        text: ['coin_337', 'coin_338', 'coin_339', 'coin_340', 'coin_341', 'coin_342'],
      },
    ],
    ...commonLearnMoreData('Polkadot (DOT)'),
  },
}
